import { Fragment } from "react/jsx-runtime";
import { ModernLoader } from "./Shared/ModernLoader";

interface GlobalLoaderProps {
  message?: string;
}

// GlobalLoader is shown when called, hidden when not rendered
// This maintains compatibility with existing usage: {loading ? <GlobalLoader /> : ""}
export default function GlobalLoader({ message }: GlobalLoaderProps = {}) {
  return (
    <Fragment>
      <div className="global-spinner">
        <ModernLoader 
          size="large"
          variant="primary"
          message={message || "Loading..."}
          fullScreen={true}
        />
      </div>
    </Fragment>
  );
}